import { ContextMenu, type ContextMenuItem } from '@/components/ui/ContextMenu/ContextMenu';
import { FaMessengerIcon } from '@/components/ui/Icons';
import type { CellComment, ReaderCellComment, SessionComment } from '@/api/client';

/** Выше `CellCommentsThreadPopover` (usePopoverPositioning zIndex: 1001). */
const CELL_COMMENT_CONTEXT_MENU_Z = 1002;

interface CellCommentContextMenuProps {
  comment: CellComment | ReaderCellComment | SessionComment | null;
  anchorPosition: { x: number; y: number } | null;
  onClose: () => void;
  onReply: (c: CellComment | ReaderCellComment | SessionComment) => void;
  canReply?: boolean;
}

export function CellCommentContextMenu({
  comment,
  anchorPosition,
  onClose,
  onReply,
  canReply = true,
}: CellCommentContextMenuProps) {
  if (!comment) return null;

  const items: ContextMenuItem[] = canReply
    ? [
        {
          label: 'Ответить',
          icon: <FaMessengerIcon icon="replyd" size={21} />,
          onClick: () => onReply(comment),
        },
      ]
    : [];

  if (items.length === 0) return null;

  return (
    <ContextMenu
      isOpen={anchorPosition !== null}
      onClose={onClose}
      anchorPosition={anchorPosition}
      items={items}
      zIndex={CELL_COMMENT_CONTEXT_MENU_Z}
    />
  );
}
